import type { ReactNode } from "react";
import styles from "./VisuallyHidden.module.css";

/** Text for screen readers only (status announcements, extra context for icon-only controls). */
export function VisuallyHidden({ children, id }: { children: ReactNode; id?: string }) {
  return (
    <span className={styles.hidden} id={id}>
      {children}
    </span>
  );
}
